import fetch from '@/fetch'
// 获取select下拉列表数据
export const getSelectList = (params) => {
  return fetch({
    method: 'post',
    url: '/api/common/dropdownlist',
    data: params
  })
}
